import React, {FC} from 'react';

import TimerContainer from '@/src/timer/containers/TimerContainer';

import {ApplicationContainer, SectionContainer} from '../../../ui';
import Footer from '../../footer/components/Footer';
import Header from '../../header/components/Header';
import MobileSingInBlock from '../../header/components/MobileSingInBlock';
import css from '../styles/LayoutSingUp.module.css';
import SignupBenefitsLayout from './SignupBenefitsLayout';

interface LayoutSingUpProps {
  children: React.ReactNode;
  withSignInButton?: boolean;
  step?: 1 | 2;
}

const LayoutSingUp: FC<LayoutSingUpProps> = ({
  children,
  withSignInButton = true,
  step,
}) => {
  return (
    <ApplicationContainer>
      <div className={css.wrapper}>
        <Header withSignInButton={withSignInButton} />

        <div className={css.main}>
          <div>
            <SectionContainer>
              <div className={css.timerWrapper}>
                <TimerContainer isRounded />
              </div>
            </SectionContainer>
            <SignupBenefitsLayout step={step}>{children}</SignupBenefitsLayout>
          </div>
        </div>
        {withSignInButton && <MobileSingInBlock />}
        <Footer />
      </div>
    </ApplicationContainer>
  );
};

export default LayoutSingUp;
